import { render } from "./Checkbox.vue?vue&type=template&id=58ac2a43&scoped=true"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import "./Checkbox.vue?vue&type=style&index=0&id=58ac2a43&lang=scss&scoped=true"

import exportComponent from "/home/blissfulapps/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ac2a43"]])

export default __exports__